import type { IGlobalMarkThemeByName } from '@visactor/vchart';

export const markByName: IGlobalMarkThemeByName = {
  label: {
    style: {
      fontSize: 12,
      fill: { type: 'palette', key: 'blackColors65' },
      lineWidth: 0
    }
  }
};
